import { localizedTitle } from "@/lib/i18n/ssrSeo";
import { seoFor } from "@/lib/i18n/keywordPools";
import { createFileRoute } from "@tanstack/react-router";
import LeaguesIndex from "@/pages/LeaguesIndex";
import { MainLayout } from "@/components/layout/MainLayout";

export const Route = createFileRoute("/leagues/")({
  head: () => {
    const L = localizedTitle("/leagues", { title: "Football Predictions by League: EPL, La Liga | Statlign", description: "AI football predictions grouped by league. Every match week, every top division — with the historical accuracy that earned each pick." });
    return {
    meta: [
      { title: L.title },
      { name: "keywords", content: seoFor({ topics: ["leagues"] }).meta },
      { name: "description", content: L.description },
      { property: "og:title", content: L.title },
      { property: "og:type", content: "website" },
      { property: "og:description", content: L.description },
      { name: "twitter:title", content: L.title },
      { name: "twitter:description", content: L.description },
    ],
  };
  },
  component: () => (
    <MainLayout>
      <LeaguesIndex />
    </MainLayout>
  ),
});
